import React, { PureComponent } from 'react';
import Spinner from '@atlaskit/spinner';
import Tabs from '@atlaskit/tabs';
import { TABS } from '../config';

const defaultTabIndex = 1;
const ONE_WEEK = 604800000;

export default class TabbedComponents extends PureComponent {
  state = {
    selectedTabIndex: defaultTabIndex,
    showInternal: false,
    showOnlyRecent: false,
  }

  renderHeader = () => {
    const { header: Header, extraProps = {} } = this.props;
    if (Header) {
      return <Header {...extraProps} />
    }
    return <span />;
  }

  onShowInternalChange = (event) => {
    this.setState({ showInternal: event.target.checked});
  }

  showOnlyRecentChange = (event) => {
    this.setState({ showOnlyRecent: event.target.checked});
  }

  sortRows = (column) => {
    return () => {
      if (this.state.sortBy !== column) {
        this.setState({
          sortBy: column,
          sortOrder: 1
        })
      } else {
        this.setState({
          sortOrder: this.state.sortOrder === 1 ? -1 : 1,
        })
      }
    }
  }

  renderFilters = () => {
    return <div style={{padding: '12px 0 0 0', display: 'flex', }}>
      <label style={{ paddingRight: '8px'}}>
        <input
          type="checkbox"
          checked={this.state.showInternal}
          onChange={this.onShowInternalChange}
          style={{marginLeft: 0}}
        /> Internal
      </label>
      <label>
        <input type="checkbox" checked={this.state.showOnlyRecent} onChange={this.showOnlyRecentChange}/> Recently updated
      </label>
    </div>
  }

  renderHeading = () => {
    return <div className="row table-row">
      <div className="col-2" onClick={this.sortRows('name')}>Name</div>
      <div className="col-6" onClick={this.sortRows('description')}>Description</div>
      <div className="col-2" onClick={this.sortRows('publishTime')}>Updated</div>
    </div>
  }

  renderTabContent = () => {
    const { components, row: Row, extraProps = {} } = this.props;
    const selectedTab = TABS[this.state.selectedTabIndex];
    const filteredComponents = components.filter(selectedTab.filter);
    const sortedComponents = selectedTab.sort ? filteredComponents.sort(selectedTab.sort) : filteredComponents;
    return (
      <div style={{width: '100%'}}>
        {this.renderFilters()}
        {this.renderHeading()}
        {
          sortedComponents.sort((a, b) => {
            if(a[this.state.sortBy] < b[this.state.sortBy]) return -1 * this.state.sortOrder;
            if(a[this.state.sortBy] > b[this.state.sortBy]) return 1 * this.state.sortOrder;
            return 0;
          }).filter((component) => {
            if (!this.state.showInternal && component.keywords.indexOf('internal') > -1) {
              return false;
            } else if (this.state.showOnlyRecent && (component.publishTimestamp < (Date.now() - ONE_WEEK))) {
              return false;
            }
            return true;
          }).map((tabComponent, index) => (
            <div style={{ width: '100%' }} key={index}>
              <Row
                key={tabComponent.name}
                component={tabComponent}
                {...extraProps}
              />
            </div>
          ))
        }
      </div>
    );
  }

  handleTabChange = (selectedTabIndex) => {
    this.setState({ selectedTabIndex });
  }

  render(elem) {
    const { components, row: Row } = this.props;
    if (!Row || !components || !components.length) return <Spinner />;

    const Header = this.renderHeader;
    const Content = this.renderTabContent;
    return (
      <div>
        <Header />
        <Tabs
          onSelect={this.handleTabChange}
          tabs={TABS.map((tab, tabIndex) => ({
            defaultSelected: tabIndex === defaultTabIndex,
            label: tab.title,
            content: <Content />
          }))}
        />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/TabbedComponents.jsx